import { useEffect, useState } from 'react';
import { useGridFilter, type CustomFilterProps } from 'ag-grid-react';

type ValueModel = { values: string[] };
const keyOf = (value: unknown) => value == null ? '' : String(value);

export default function ColumnValuesFilter({ api, getValue, model, onModelChange, valueLabel }: CustomFilterProps<any, any, ValueModel> & { valueLabel?: (value: unknown) => string }) {
  const [search, setSearch] = useState('');
  const [values, setValues] = useState<string[]>([]);
  useEffect(() => {
    const update = () => {
      const unique = new Set<string>();
      api.forEachNode(node => { if (node.data) unique.add(keyOf(getValue(node))); });
      setValues([...unique].sort((left, right) => left.localeCompare(right, 'tr', { numeric: true })));
    };
    update();
    api.addEventListener('rowDataUpdated', update);
    return () => { if (!api.isDestroyed()) api.removeEventListener('rowDataUpdated', update); };
  }, [api, getValue]);
  useGridFilter({ doesFilterPass: ({ node }) => model === null || model.values.includes(keyOf(getValue(node))) });
  const label = (value: string) => valueLabel ? valueLabel(value || null) : value || '(Boş)';
  const selected = new Set(model?.values ?? values);
  const visible = values.filter(value => label(value).toLocaleLowerCase('tr').includes(search.toLocaleLowerCase('tr')));
  const toggle = (value: string) => {
    const next = new Set(selected);
    if (next.has(value)) next.delete(value); else next.add(value);
    onModelChange(next.size === values.length && values.every(item => next.has(item)) ? null : { values: [...next] });
  };
  return <div className="w-64 space-y-2 p-3 text-sm text-slate-700">
    <input aria-label="Filtre değerlerinde ara" placeholder="Değer ara…" value={search} onChange={event => setSearch(event.target.value)} className="w-full rounded border border-slate-200 px-2 py-1.5 outline-none focus:border-blue-400" />
    <div className="flex gap-3 border-b border-slate-100 pb-2 text-xs"><button type="button" onClick={() => onModelChange(null)} className="font-semibold text-blue-600">Tümünü seç</button><button type="button" onClick={() => onModelChange({ values: [] })} className="text-slate-500">Seçimi temizle</button></div>
    <div className="max-h-64 space-y-1 overflow-y-auto">{visible.map(value => <label key={value} className="flex cursor-pointer items-center gap-2 rounded px-1 py-1 hover:bg-slate-50"><input type="checkbox" checked={selected.has(value)} onChange={() => toggle(value)} /><span className="break-words">{label(value)}</span></label>)}{!visible.length && <p className="py-2 text-xs text-slate-400">Değer bulunamadı.</p>}</div>
  </div>;
}
